// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background-color: #dde8b9;
  font-family: 'Circular', sans-serif;
  font-weight: normal;
}

/* Layout Wrapper */
.kernteamportal-wrapper {
  padding: 2rem;
}

.area-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  justify-content: center;
  padding: 1rem;
  margin-top: 1.5rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Karte mit GRID */
.area-card {
  background-color: #ccc;
  border-radius: 20px;
  padding: 1rem;
  color: white;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  text-align: left;
  height: auto;
  min-height: 400px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 420px;
  font-weight: normal;
}


/* Hover Effekt */
.area-card:hover {
  transform: translateY(-5px);
}

/* Titel */
.area-card h2 {
  font-size: 1.8rem;
  font-family: 'Staatliches', sans-serif;
  margin: 0;
  text-transform: uppercase;
  color: white;
  font-weight: normal;
}

/* Beschreibung */
.area-card p {
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  color: white;
  line-height: 1.5;
  margin: 0;
  font-weight: normal;
}

/* Symbol */
.area-icon {
  font-family: 'Material Symbols Outlined';
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 60;
  font-size: 12.5rem !important;
  color: white;
  margin-top: auto; /* Ganz nach unten */
  align-self: center; /* Links ausrichten */
  font-weight: 200;
}

/* Farben für einzelne Bereiche */
.area-card.arbeit {
  background-color: #F4AF20;
}

.area-card.freizeit {
  background-color: #ee5622;
}

.area-card.listen {
  background-color: #0074b3;
}

.area-card.logistik {
  background-color: var(--logistik);
}

.section-title.teal {
  color: var(--logistik) !important;
}

.button_boring_red.teal {
  background-color: var(--logistik) !important;
}

.button_boring_red.teal:hover {
  background-color: var(--logistik-hover) !important;
}

/* Login Screen */
.login-screen {
  height: 100vh;
  background-color: #dde8b9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-screen form {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.login-screen input {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #aaa;
  font-family: 'Circular', sans-serif;
}

.login-screen button {
  background-color: #648202;
  color: #FFFFFF;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
  text-transform: uppercase;
}

.login-screen button:hover {
  background-color: #5a7502;
}

.area-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  width: 100%;
}

.area-content h2 {
  font-size: 1.8rem;
  font-family: 'Staatliches', sans-serif;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  color: white;
  text-align: left;
  font-weight: normal;
}

/* Beschreibung */
.area-content p {
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  color: white;
  line-height: 1.5;
  margin: 0;
  text-align: left !important;
  font-weight: normal;
}

/* Button-Container */

/* Button-Stil mit neuem Rotton */
.button_boring_red.orange {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  margin: 2px;
  background-color: #F39200 !important;
  color: white;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  font-weight: normal;
  text-transform: uppercase;
  padding: 1rem 1rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  line-height: 1.2;
  min-height: 120px;
}

/* Hover-Farbe angepasst */
.button_boring_red:hover {
  background-color: #F39200;
}

/* Kinder-Bereich (dunkelgrün) */
.section-title.kinder {
  color: var(--dunkelgruen) !important;
}

.button_boring_red.kinder {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  margin: 2px;
  background-color: var(--dunkelgruen) !important;
  color: white;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  font-weight: normal;
  text-transform: uppercase;
  padding: 1rem 1rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  line-height: 1.2;
  min-height: 120px;
}

.button_boring_red.kinder:hover {
  background-color: #5a7502 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease, transform 0.2s ease;
}

/* Icon-Stil */
.button_boring_red .material-icons {
  font-size: 2rem;
  margin-top: 0.2rem;
  font-weight: normal;
}

.button_boring_red .material-symbols-outlined {
  color: white;
  font-size: 2rem; /* optional: passt Größe an */
}

/* Alle Standard-Buttons bekommen diesen Stil */
button {
  background-color: #648202;
  color: #FFFFFF;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  font-weight: normal;
  text-transform: uppercase;
  padding: 1rem 1rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  line-height: 1.2;
  min-height: 60px;
}

button:hover {
  background-color: #5a7502;
}

.kernteam-layout-content {
  position: relative;
  z-index: 1;
  animation: contentReveal 650ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
}

.kernteam-layout-content .section-title {
  animation: titleReveal 450ms ease-out both;
  animation-delay: 80ms;
}

.kernteam-layout-content .button-container > * {
  --stagger: 0;
  animation: buttonRise 680ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
  animation-delay: calc(var(--stagger) * 60ms + 160ms);
}

.kernteam-layout-content .button-container > *:nth-child(1) { --stagger: 1; }
.kernteam-layout-content .button-container > *:nth-child(2) { --stagger: 2; }
.kernteam-layout-content .button-container > *:nth-child(3) { --stagger: 3; }
.kernteam-layout-content .button-container > *:nth-child(4) { --stagger: 4; }
.kernteam-layout-content .button-container > *:nth-child(5) { --stagger: 5; }
.kernteam-layout-content .button-container > *:nth-child(6) { --stagger: 6; }
.kernteam-layout-content .button-container > *:nth-child(7) { --stagger: 7; }
.kernteam-layout-content .button-container > *:nth-child(8) { --stagger: 8; }
.kernteam-layout-content .button-container > *:nth-child(9) { --stagger: 9; }
.kernteam-layout-content .button-container > *:nth-child(10) { --stagger: 10; }
.kernteam-layout-content .button-container > *:nth-child(11) { --stagger: 11; }
.kernteam-layout-content .button-container > *:nth-child(12) { --stagger: 12; }

.kernteam-layout-content .back-arrow {
  animation: backArrowFade 700ms ease-out both;
  animation-delay: 80ms;
}

/* Nach dem ersten Laden der Sitzung: jede weitere Navigation ist
   animationsfrei (Reveals lenken im Camp-Alltag nur ab). */
.kernteam-layout-content.no-intro,
.kernteam-layout-content.no-intro .section-title,
.kernteam-layout-content.no-intro .button-container > *,
.kernteam-layout-content.no-intro .back-arrow {
  animation: none;
}

.page-transition {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 25;
  opacity: 0;
}

.page-transition::before,
.page-transition::after {
  content: "";
  position: absolute;
  inset: -20%;
  opacity: 0;
  transform: translateX(-120%) skewX(-12deg);
}

.page-transition::before {
  background: linear-gradient(120deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.7) 45%, rgba(255, 255, 255, 0) 70%);
  mix-blend-mode: screen;
  filter: blur(2px);
}

.page-transition::after {
  background: linear-gradient(120deg, rgba(0, 80, 123, 0) 0%, rgba(0, 80, 123, 0.4) 45%, rgba(0, 80, 123, 0) 70%);
  transform: translateX(120%) skewX(-12deg);
  mix-blend-mode: multiply;
}

.page-transition.active::before {
  animation: sweepPrimary 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
}

.page-transition.active::after {
  animation: sweepSecondary 1100ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
}

@keyframes contentReveal {
  0% {
    opacity: 0;
    transform: translateY(16px) scale(0.98);
    filter: blur(4px);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@keyframes titleReveal {
  0% {
    opacity: 0;
    transform: translateY(6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes buttonRise {
  0% {
    opacity: 0;
    transform: translateY(18px) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes backArrowFade {
  0% {
    opacity: 0;
    filter: blur(2px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
  }
}

@keyframes sweepPrimary {
  0% {
    opacity: 0;
    transform: translateX(-120%) skewX(-12deg);
  }
  25% {
    opacity: 1;
  }
  70% {
    opacity: 0.9;
  }
  100% {
    opacity: 0;
    transform: translateX(120%) skewX(-12deg);
  }
}

@keyframes sweepSecondary {
  0% {
    opacity: 0;
    transform: translateX(120%) skewX(-12deg);
  }
  20% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
    transform: translateX(-120%) skewX(-12deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .page-transition,
  .page-transition::before,
  .page-transition::after,
  .kernteam-layout-content,
  .kernteam-layout-content .section-title,
  .kernteam-layout-content .button-container > *,
  .kernteam-layout-content .back-arrow {
    animation: none !important;
    transition: none !important;
  }
}


@media (max-width: 768px) {
  .area-container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .button-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .area-card {
    min-height: 300px;
  }

  .area-card h2 {
    font-size: 1.5rem;
  }

  .area-content p {
  font-family: 'Circular', sans-serif;
    font-size: 0.9rem;
  }

  .area-icon {
    font-size: 8rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/KernteamLayout.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA,iBAAiB;AACjB;EACE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,sCAAsC;EACtC,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,wCAAwC;EACxC;;;;aAIW;EACX,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB,EAAE,oBAAoB;EACtC,kBAAkB,EAAE,qBAAqB;EACzC,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,+CAA+C;EAC/C,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA,cAAc;AACd;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe,EAAE,6BAA6B;AAChD;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kEAAkE;AACpE;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,+DAA+D;EAC/D,oDAAoD;AACtD;;AAEA,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,8DAA8D,YAAY,EAAE;AAC5E,+DAA+D,aAAa,EAAE;AAC9E,+DAA+D,aAAa,EAAE;AAC9E,+DAA+D,aAAa,EAAE;;AAE9E;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;2DAC2D;AAC3D;;;;EAIE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,wHAAwH;EACxH,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,+GAA+G;EAC/G,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;IACvC,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iCAAiC;IACjC,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;EAC5C;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,0CAA0C;EAC5C;AACF;;AAEA;EACE;;;;;;;IAOE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;;AAGA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;EACA,mCAAmC;IACjC,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background-color: #dde8b9;\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n}\n\n/* Layout Wrapper */\n.kernteamportal-wrapper {\n  padding: 2rem;\n}\n\n.area-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n  justify-content: center;\n  padding: 1rem;\n  margin-top: 1.5rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Karte mit GRID */\n.area-card {\n  background-color: #ccc;\n  border-radius: 20px;\n  padding: 1rem;\n  color: white;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  height: auto;\n  min-height: 400px;\n  width: 100%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  max-width: 420px;\n  font-weight: normal;\n}\n\n\n/* Hover Effekt */\n.area-card:hover {\n  transform: translateY(-5px);\n}\n\n/* Titel */\n.area-card h2 {\n  font-size: 1.8rem;\n  font-family: 'Staatliches', sans-serif;\n  margin: 0;\n  text-transform: uppercase;\n  color: white;\n  font-weight: normal;\n}\n\n/* Beschreibung */\n.area-card p {\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  color: white;\n  line-height: 1.5;\n  margin: 0;\n  font-weight: normal;\n}\n\n/* Symbol */\n.area-icon {\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings:\n    'FILL' 0,\n    'wght' 400,\n    'GRAD' 0,\n    'opsz' 60;\n  font-size: 12.5rem !important;\n  color: white;\n  margin-top: auto; /* Ganz nach unten */\n  align-self: center; /* Links ausrichten */\n  font-weight: 200;\n}\n\n/* Farben für einzelne Bereiche */\n.area-card.arbeit {\n  background-color: #F4AF20;\n}\n\n.area-card.freizeit {\n  background-color: #ee5622;\n}\n\n.area-card.listen {\n  background-color: #0074b3;\n}\n\n.area-card.logistik {\n  background-color: var(--logistik);\n}\n\n.section-title.teal {\n  color: var(--logistik) !important;\n}\n\n.button_boring_red.teal {\n  background-color: var(--logistik) !important;\n}\n\n.button_boring_red.teal:hover {\n  background-color: var(--logistik-hover) !important;\n}\n\n/* Login Screen */\n.login-screen {\n  height: 100vh;\n  background-color: #dde8b9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-screen form {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.login-screen input {\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid #aaa;\n  font-family: 'Circular', sans-serif;\n}\n\n.login-screen button {\n  background-color: #648202;\n  color: #FFFFFF;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n  text-transform: uppercase;\n}\n\n.login-screen button:hover {\n  background-color: #5a7502;\n}\n\n.area-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-grow: 1;\n  width: 100%;\n}\n\n.area-content h2 {\n  font-size: 1.8rem;\n  font-family: 'Staatliches', sans-serif;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  color: white;\n  text-align: left;\n  font-weight: normal;\n}\n\n/* Beschreibung */\n.area-content p {\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  color: white;\n  line-height: 1.5;\n  margin: 0;\n  text-align: left !important;\n  font-weight: normal;\n}\n\n/* Button-Container */\n\n/* Button-Stil mit neuem Rotton */\n.button_boring_red.orange {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin: 2px;\n  background-color: #F39200 !important;\n  color: white;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  padding: 1rem 1rem;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  text-align: left;\n  line-height: 1.2;\n  min-height: 120px;\n}\n\n/* Hover-Farbe angepasst */\n.button_boring_red:hover {\n  background-color: #F39200;\n}\n\n/* Kinder-Bereich (dunkelgrün) */\n.section-title.kinder {\n  color: var(--dunkelgruen) !important;\n}\n\n.button_boring_red.kinder {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin: 2px;\n  background-color: var(--dunkelgruen) !important;\n  color: white;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  padding: 1rem 1rem;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  text-align: left;\n  line-height: 1.2;\n  min-height: 120px;\n}\n\n.button_boring_red.kinder:hover {\n  background-color: #5a7502 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n/* Icon-Stil */\n.button_boring_red .material-icons {\n  font-size: 2rem;\n  margin-top: 0.2rem;\n  font-weight: normal;\n}\n\n.button_boring_red .material-symbols-outlined {\n  color: white;\n  font-size: 2rem; /* optional: passt Größe an */\n}\n\n/* Alle Standard-Buttons bekommen diesen Stil */\nbutton {\n  background-color: #648202;\n  color: #FFFFFF;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  padding: 1rem 1rem;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  line-height: 1.2;\n  min-height: 60px;\n}\n\nbutton:hover {\n  background-color: #5a7502;\n}\n\n.kernteam-layout-content {\n  position: relative;\n  z-index: 1;\n  animation: contentReveal 650ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n}\n\n.kernteam-layout-content .section-title {\n  animation: titleReveal 450ms ease-out both;\n  animation-delay: 80ms;\n}\n\n.kernteam-layout-content .button-container > * {\n  --stagger: 0;\n  animation: buttonRise 680ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n  animation-delay: calc(var(--stagger) * 60ms + 160ms);\n}\n\n.kernteam-layout-content .button-container > *:nth-child(1) { --stagger: 1; }\n.kernteam-layout-content .button-container > *:nth-child(2) { --stagger: 2; }\n.kernteam-layout-content .button-container > *:nth-child(3) { --stagger: 3; }\n.kernteam-layout-content .button-container > *:nth-child(4) { --stagger: 4; }\n.kernteam-layout-content .button-container > *:nth-child(5) { --stagger: 5; }\n.kernteam-layout-content .button-container > *:nth-child(6) { --stagger: 6; }\n.kernteam-layout-content .button-container > *:nth-child(7) { --stagger: 7; }\n.kernteam-layout-content .button-container > *:nth-child(8) { --stagger: 8; }\n.kernteam-layout-content .button-container > *:nth-child(9) { --stagger: 9; }\n.kernteam-layout-content .button-container > *:nth-child(10) { --stagger: 10; }\n.kernteam-layout-content .button-container > *:nth-child(11) { --stagger: 11; }\n.kernteam-layout-content .button-container > *:nth-child(12) { --stagger: 12; }\n\n.kernteam-layout-content .back-arrow {\n  animation: backArrowFade 700ms ease-out both;\n  animation-delay: 80ms;\n}\n\n/* Nach dem ersten Laden der Sitzung: jede weitere Navigation ist\n   animationsfrei (Reveals lenken im Camp-Alltag nur ab). */\n.kernteam-layout-content.no-intro,\n.kernteam-layout-content.no-intro .section-title,\n.kernteam-layout-content.no-intro .button-container > *,\n.kernteam-layout-content.no-intro .back-arrow {\n  animation: none;\n}\n\n.page-transition {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 25;\n  opacity: 0;\n}\n\n.page-transition::before,\n.page-transition::after {\n  content: \"\";\n  position: absolute;\n  inset: -20%;\n  opacity: 0;\n  transform: translateX(-120%) skewX(-12deg);\n}\n\n.page-transition::before {\n  background: linear-gradient(120deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.7) 45%, rgba(255, 255, 255, 0) 70%);\n  mix-blend-mode: screen;\n  filter: blur(2px);\n}\n\n.page-transition::after {\n  background: linear-gradient(120deg, rgba(0, 80, 123, 0) 0%, rgba(0, 80, 123, 0.4) 45%, rgba(0, 80, 123, 0) 70%);\n  transform: translateX(120%) skewX(-12deg);\n  mix-blend-mode: multiply;\n}\n\n.page-transition.active::before {\n  animation: sweepPrimary 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n}\n\n.page-transition.active::after {\n  animation: sweepSecondary 1100ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n}\n\n@keyframes contentReveal {\n  0% {\n    opacity: 0;\n    transform: translateY(16px) scale(0.98);\n    filter: blur(4px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    filter: blur(0);\n  }\n}\n\n@keyframes titleReveal {\n  0% {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes buttonRise {\n  0% {\n    opacity: 0;\n    transform: translateY(18px) scale(0.98);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes backArrowFade {\n  0% {\n    opacity: 0;\n    filter: blur(2px);\n  }\n  100% {\n    opacity: 1;\n    filter: blur(0);\n  }\n}\n\n@keyframes sweepPrimary {\n  0% {\n    opacity: 0;\n    transform: translateX(-120%) skewX(-12deg);\n  }\n  25% {\n    opacity: 1;\n  }\n  70% {\n    opacity: 0.9;\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(120%) skewX(-12deg);\n  }\n}\n\n@keyframes sweepSecondary {\n  0% {\n    opacity: 0;\n    transform: translateX(120%) skewX(-12deg);\n  }\n  20% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-120%) skewX(-12deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .page-transition,\n  .page-transition::before,\n  .page-transition::after,\n  .kernteam-layout-content,\n  .kernteam-layout-content .section-title,\n  .kernteam-layout-content .button-container > *,\n  .kernteam-layout-content .back-arrow {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .area-container {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  .button-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .area-card {\n    min-height: 300px;\n  }\n\n  .area-card h2 {\n    font-size: 1.5rem;\n  }\n\n  .area-content p {\n  font-family: 'Circular', sans-serif;\n    font-size: 0.9rem;\n  }\n\n  .area-icon {\n    font-size: 8rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
